export class SidebarWithContent {
    static init(): void {
        this.setComponent();
    }

    private static setComponent(): void {
        const container = document.querySelector('.sidebar-with-content');

        if (!container) return;

        const tabs = container.querySelectorAll('.tab');
        const contents = container.querySelectorAll('.tab-content');
        const prevBtn = container.querySelector('#prev-btn');
        const nextBtn = container.querySelector('#next-btn');
        const prevBtnText = prevBtn?.querySelector('#prev-text');
        const nextBtnText = nextBtn?.querySelector('#next-text');

        tabs[0].setAttribute('aria-selected', 'true');
        contents[0].classList.toggle('hidden');

        updatePagination(0);

        tabs.forEach((tab, index) => {
            tab.addEventListener('click', () => {
                tabs.forEach(tab => tab.setAttribute('aria-selected', 'false'))
                contents.forEach(content => content.classList.add('hidden'));

                tab.setAttribute('aria-selected', 'true');
                contents[index].classList.toggle('hidden');

                updatePagination(index);
            })
        })

        nextBtn?.addEventListener('click', () => {
            changeTab(true);
        })

        prevBtn?.addEventListener('click', () => {
            changeTab(false);
        })

        function updatePagination(currentTabIndex: number): void {
            if (!prevBtn || !nextBtn || !prevBtnText || !nextBtnText) return;

            const isFirstTab = currentTabIndex === 0;
            const isLastTab = currentTabIndex === tabs.length - 1;

            prevBtn.classList.toggle('hidden', isFirstTab);
            if (!isFirstTab) {
                prevBtnText.textContent = tabs[currentTabIndex - 1].textContent;
            }
            
            nextBtn.classList.toggle('hidden', isLastTab);
            if (!isLastTab) {
                nextBtnText.textContent = tabs[currentTabIndex + 1].textContent;
            }
        }

        function changeTab(next: boolean): void {        
            const currentTabIndex = Array.from(tabs).findIndex(tab => tab.getAttribute('aria-selected') === 'true')

            const newIndex = next
                ? currentTabIndex + 1
                : currentTabIndex - 1;

            tabs.forEach(tab => tab.setAttribute('aria-selected', 'false'))
            contents.forEach(content => content.classList.add('hidden'));

            tabs[newIndex].setAttribute('aria-selected', 'true');
            contents[newIndex].classList.toggle('hidden');

            updatePagination(newIndex);
        }
    }
}